/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';

/**
 * 
 * @export
 * @interface NewOrganizationMemberDTO
 */
export interface NewOrganizationMemberDTO {
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationMemberDTO
     */
    userId: string;
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof NewOrganizationMemberDTO
     */
    role: OrganizationRoleDTO;
}



/**
 * Check if a given object implements the NewOrganizationMemberDTO interface.
 */
export function instanceOfNewOrganizationMemberDTO(value: object): value is NewOrganizationMemberDTO {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function NewOrganizationMemberDTOFromJSON(json: any): NewOrganizationMemberDTO {
    return NewOrganizationMemberDTOFromJSONTyped(json, false);
}

export function NewOrganizationMemberDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewOrganizationMemberDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'role': OrganizationRoleDTOFromJSON(json['role']),
    };
}

export function NewOrganizationMemberDTOToJSON(value?: NewOrganizationMemberDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'role': OrganizationRoleDTOToJSON(value['role']),
    };
}

